import { generateJSON } from '@tiptap/core';
import { memo, useMemo } from 'react';
import { EditorStyles } from '../EditorContainer/EditorStyles';
import { Renderer } from './Renderer';
import { parseContentToPlainText } from './editorContentToPlaintext';
import { EditorContentViewProps } from './types';

export const EditorContentView = memo(
  ({ content, editor, plaintext, className }: EditorContentViewProps) => {
    const def = useMemo(
      () =>
        typeof content === 'object'
          ? content
          : generateJSON(content, editor.options.extensions),
      [content, editor.options.extensions],
    );

    if (plaintext) {
      return <>{parseContentToPlainText(editor, def)}</>;
    }

    return (
      <EditorStyles className={className}>
        <Renderer editor={editor}>{def}</Renderer>
      </EditorStyles>
    );
  },
  // rerender only if content changes
  (prev, next) => prev.content === next.content,
);
